/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetEvChargingStationLiveStatusPathParameters } from 'api/actions/get-ev-charging-station-live-status/get-ev-charging-station-live-status-path-parameters';
import { GetEvChargingStationLiveStatusResponse } from 'api/actions/get-ev-charging-station-live-status/get-ev-charging-station-live-status-response';

type GetEvChargingStationLiveStatusQueryParameters = Record<string, any>;

/**
 * The path of the GetEvChargingStationLiveStatus action.
 */
export const getEvChargingStationLiveStatusActionPath = new SweetPath<
  keyof GetEvChargingStationLiveStatusPathParameters
>('/ev-charging-stations/{evChargingStationId}/live-status', { path: '{param}' });

/**
 * Creates a contextualized GetEvChargingStationLiveStatus actions.
 */
export default function createGetEvChargingStationLiveStatusAction(axios: AxiosInstance) {
  return function getEvChargingStationLiveStatusAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetEvChargingStationLiveStatusPathParameters;
    query?: GetEvChargingStationLiveStatusQueryParameters;
  }) {
    const path = getEvChargingStationLiveStatusActionPath.insert(parameters);

    return axios.get<GetEvChargingStationLiveStatusResponse, GetEvChargingStationLiveStatusResponse>(path, {
      params: query,
      headers,
    });
  };
}
